export interface SupercontrolDate {
  date: string
}
export interface GuestData {
  adults: number
  children: number
  infants: number
}
export interface PropertyData {
  arrival: SupercontrolDate
  cottage_id: number
  departure: SupercontrolDate
  guests: GuestData
}
export interface CartData {
  calendar_key: string
  properties: PropertyData[]
  ref?: string
  voucher?: string
  update_content?: boolean
}

export interface BookingProtect {
  cost: number
  currency: string
  offer_ref: any
  product_ref: any
  terms_url: any
}

export interface Address {
  city: string
  country: string
  county: string
  line_1: string
  line_2: string
  postcode: string
}

export interface Customer {
  address: Address
  company: string
  email: string
  firstname: string
  lastname: string
  mobile: string
  telephone: string
  title: string
}

export interface Price {
  balance: number
  deposit: number
  interim: number
  total_final: number
  total_original: number
}

export interface PropertyDate {
  date: string
  max: string
  min: string
  time: string
}

export interface PropertyCapacity {
  adults: number[]
  capacity_notes: string
  children: number[]
  infants: number[]
  infants_definition: string
  sleeps: number
}

export interface PropertyError {
  has_error: boolean
  msg: string
}

export interface PropertyExtraPrice {
  currency_symbol: string
  rate: number
  total: number
  unit: string
  unit_label: string
}

export interface PropertyExtra {
  available: number[]
  description: string
  id: number
  img: any
  is_default: boolean
  is_hidden: boolean
  msg: string
  name: string
  qty: number
  price: PropertyExtraPrice
}

export interface PropertyExtras {
  category: string
  extras: PropertyExtra[]
}

export interface PropertyGuests {
  adults: number
  children: number
  infants: number
  details: any[]
}

export interface PropertyPrice {
  value: number
  due: string
  base: number
}

export interface PropertyPriceGroup {
  balance: PropertyPrice
  deposit: PropertyPrice
  interim: PropertyPrice
  total_base: number
  total_final: number
  total_original: number
  vat_rate: number
}

export interface PropertyRentalGuardian {
  included: boolean
  price: number
}

export interface PropertySecurityDeposit {
  msg: string
  payable_with: any
  type: number
  use: boolean
  value: number
}

export interface PropertyRentalPricingNotes {
  date_limits: any[]
  fixed: string
}

export interface Property {
  arrival: PropertyDate
  capacity: PropertyCapacity
  cottage_id: number
  damage_waiver: any
  departure: PropertyDate
  discounts: any
  error: PropertyError
  extras: PropertyExtras[]
  guests: PropertyGuests
  img: string
  name: string
  price: PropertyPriceGroup
  refundable_deposit: any
  rental_guardian: PropertyRentalGuardian
  rental_pricing_notes: PropertyRentalPricingNotes
  security_deposit: PropertySecurityDeposit
  special_offset: number
}

export interface CartResponseData {
  booking_protect: BookingProtect
  currency: string
  customer: Customer
  price: Price
  properties: Property[]
  voucher: any
}

export interface ContentResponseData {
  airports: any
  booking_sources: any
  consent: any
  countries: any
  custom_content: string
  custom_fields: any
  logo: string
  payment_methods: any
  postcode_looup: any
  premier_cottages: any
  url: any
}

export interface SettingsResponseData {
  arrival_time: string
  departure_time: string
  guest_details: any
  show_agent_login: boolean
  show_flight_info: boolean
  source_required: boolean
}

export interface CartResponse {
  cart: CartResponseData
  content: ContentResponseData
  gaId: string
  owner_id: number
  payment_processor: string
  payment_url: string
  redirect: string
  ref: string
  settings: SettingsResponseData
  site_id: number
  transfer_enabled: boolean
  transfer_url: string
}

export interface ErrorResponse {
  hasError: boolean
  details: string
}

const baseUrl = 'https://api.supercontrol.co.uk/v3/cart/'

export const createCart = async (data: CartData): Promise<CartResponse|ErrorResponse> => {
  delete data.update_content
  const response = await fetch(`${baseUrl}create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
  })
  return await response.json()
}

export const updateCart = async (data: CartData, updateContent: boolean = false): Promise<CartResponse|ErrorResponse> => {
  if (updateContent)
    data.update_content = true
  else
    delete data.update_content

  const response = await fetch(`${baseUrl}update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
  })
  return await response.json()
}

export const placeOrder = async (order: any, id: string = null): Promise<any> => {
  const wordpressUrl = (window as any).siteInfo.url
  const data = {
    order,
    id,
  }

  const response = await fetch(`${wordpressUrl}/wp-json/accommodation/order`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json()
}

export const updateOrder = async (id: string, intentId: string, data: any): Promise<any> => {
  const wordpressUrl = (window as any).siteInfo.url

  const response = await fetch(`${wordpressUrl}/wp-json/accommodation/order-update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id,
      intentId,
      data,
    })
  })

  return await response.json()
}
